<template>
  <div class="bill_box">
    <div class="bill_boxs">
      <div class="bill_first">
        <div class="bill_head loos">待结算未税金额</div>
        <div class="leww">
          <div class="bill_within">USD {{this.stayTaxUsd}}</div>
          <div class="bill_within">RMB {{this.stayTaxRmb}}</div>
        </div>
      </div>
      <div class="buill_second">
        <div class="bill_head lees">待结算含税金额</div>
        <div class="leww">
          <div class="bill_within">USD {{this.stayTaxinclusiveUsd}}</div>
          <div class="bill_within lws">RMB {{this.stayTaxinclusiveRmb}}</div>
        </div>
      </div>
    </div>
    <el-container>
      <el-header class="bill_top">
        <el-row class="bill_label">
          <el-col :class="print1 === 0 ? 'bill_each' : 'bill_actives'">
            <div class="eventStatus" @click="printEvent(1)">全部</div>
          </el-col>
          <el-col :class="print2 === 0 ? 'bill_each' : 'bill_actives'">
            <div class="eventStatus" @click="printEvent(2)">待确认</div>
          </el-col>
          <el-col :class="print3 === 0 ? 'bill_each' : 'bill_actives'">
            <div class="eventStatus" @click="printEvent(3)">待对账</div>
          </el-col>
          <el-col :class="print4 === 0 ? 'bill_each' : 'bill_actives'">
            <div class="eventStatus" @click="printEvent(4)">已对账</div>
          </el-col>
        </el-row>
        <!-- 表单 -->
        <el-form
          style="height: 120px;"
          :inline="true"
          :model="inquireForm"
          ref="inquireForm"
          class="order_search"
        >
          <el-form-item label="订单编号" prop="number">
            <el-input v-model="inquireForm.number" placeholder="请输入订单"></el-input>
          </el-form-item>
          <el-form-item label="提单号" prop="mark">
            <el-input v-model="inquireForm.mark" placeholder="请输入提单号"></el-input>
          </el-form-item>
          <el-form-item label="结算方式" prop="clearing">
            <el-select v-model="inquireForm.clearing" placeholder="全部">
              <el-option label="全部" value></el-option>
              <el-option label="现结" value="30"></el-option>
              <el-option label="周结" value="10"></el-option>
              <el-option label="月结" value="20"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期" prop="value1">
            <el-date-picker
              v-model="inquireForm.value1"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="截止日期" prop="value2">
            <el-date-picker
              v-model="inquireForm.value2"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item style="float: right;">
            <el-button type="primary" class="order-inquire" @click="inquire(inquireForm)">查询</el-button>
            <el-button class="order-reset" @click="resetForm('inquireForm')">重置</el-button>
          </el-form-item>
          <ul class="bill_fye">
            <li class="bill_ye bill_ye1">订单编号</li>
            <li class="bill_ye bill_ye2">提单号</li>
            <li class="bill_ye bill_ye3">结算方式</li>
            <li class="bill_ye bill_ye4">开航日</li>
            <li class="bill_ye bill_ye5">总计未税金额</li>
            <li class="bill_ye bill_ye6">总计含税金额</li>
            <li class="bill_ye bill_ye7">操作</li>
          </ul>
        </el-form>
      </el-header>
      <el-main class="bill_content">
        <div v-show="listForm.length == 0">
          <div class="box-no-hezi">
            <div class="box-no-data"></div>
            <div class="box-no-font">您还未通过平台下单</div>
          </div>
        </div>
        <ul class="bill_orr">
          <li class="bill_lits" v-for="(item,index) in listForm">
            <div class="bill_wws bill_ws1">{{item.orderNo}}</div>
            <div class="bill_wws bill_ws2">{{item.mawbNo}}</div>
            <div class="bill_wws bill_ws3" v-if="!item.paymentMethod"></div>
            <div class="bill_wws bill_ws3" v-if="item.paymentMethod == 10">周结</div>
            <div class="bill_wws bill_ws3" v-if="item.paymentMethod == 20">月结</div>
            <div class="bill_wws bill_ws3" v-if="item.paymentMethod == 30">现结</div>
            <div class="bill_wws bill_ws4">{{item.estimatedTimeDelivery}}</div>
            <div class="bill_wws bill_ws5">
              <span style="display: block;">USD {{item.totalUSDSettUntaxedAmount}}</span>
              <span style="display: block;">RMB {{item.totalCNYSettUntaxedAmount}}</span>
            </div>
            <div class="bill_wws bill_ws6">
              <span style="display: block;">USD {{item.totalUSDSettTaxAmount}}</span>
              <span style="display: block;">RMB {{item.totalCNYSettTaxAmount}}</span>
            </div>
            <div class="bill_wwss bill_ws7">
              <div class="bill_unfold" id="clab" @click="unfold($event,index,item)">展开</div>
            </div>
            <div
              class="attta"
              id="clabs"
              style="margin-bottom: 30px;  "
              :class="{active:flag[index]}"
            >
              <el-table
                :data="item.accountDetailManageVos"
                class="ot_text"
                style="border: 1px #EAEAEA solid;  "
              >
                <el-table-column prop="chargeName" label="费用项目" width="120"></el-table-column>
                <el-table-column prop="unit" label="计价单位" width="120"></el-table-column>
                <el-table-column prop="quantity" label="数量" width="100"></el-table-column>
                <el-table-column prop="taxPrice" label="单价" width="100"></el-table-column>
                <el-table-column prop="settCurrency" label="币别" width="100"></el-table-column>
                <el-table-column prop="taxPoint" label="税点" width="100"></el-table-column>
                <el-table-column prop="settUntaxedAmount" label="合计未税金额" width="150"></el-table-column>
                <el-table-column prop="settTaxAmount" label="合计含税金额" width="150"></el-table-column>
              </el-table>
              <div class="sum_box">
                <div class="sum_box1">
                  <span class="sum_money">总金额</span>
                  <span class="sum_Currency">USD</span>
                  <span class="sum_untaxed">{{item.totalUSDSettUntaxedAmount}}</span>
                  <span class="sum_summation">{{item.totalUSDSettTaxAmount}}</span>
                </div>
                <div class="sum_box2">
                  <span class="sum_Currency">RMB</span>
                  <span class="sum_untaxed">{{item.totalCNYSettUntaxedAmount}}</span>
                  <span class="sum_summation">{{item.totalCNYSettTaxAmount}}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <!-- 分页 -->
        <el-pagination
          class="paging"
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="PageSize"
          layout=" prev, pager, next"
          :total="totalCount"
        ></el-pagination>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Settlement: "",
      flag: [],
      zoom: "w",
      currentPage: 1, //默认开始页面
      totalCount: 1, //总条数
      PageSize: 8, //每页的数据条数
      print1: 1,
      print2: 0,
      print3: 0,
      print4: 0,
      inquireForm: {
        number: "", //编号
        mark: "", //提单号
        clearing: "", //结算方式
        value1: "", //开始时间
        value2: "" //截止时间
      },
      listForm: [
        {
          billsAuditStatus: "10",
          estimatedTimeDelivery: "2020-07-08 00:00:00",
          mawbNo: null,
          orderNo: "T2020063000002",
          paymentMethod: 30,
          totalCNYSettTaxAmount: 36124.8,
          totalCNYSettUntaxedAmount: 34080,
          totalUSDSettTaxAmount: 0,
          totalUSDSettUntaxedAmount: 0
        },
        {
          billsAuditStatus: "10",
          estimatedTimeDelivery: "2020-07-02 00:00:00",
          mawbNo: null,
          orderNo: "T2020062800006",
          paymentMethod: 30,
          totalCNYSettTaxAmount: 30.3,
          totalCNYSettUntaxedAmount: 30,
          totalUSDSettTaxAmount: 0,
          totalUSDSettUntaxedAmount: 0
        },
        {
          billsAuditStatus: "10",
          estimatedTimeDelivery: "2020-07-02 00:00:00",
          mawbNo: null,
          orderNo: "T2020062800004",
          paymentMethod: 30,
          totalCNYSettTaxAmount: 0,
          totalCNYSettUntaxedAmount: 0,
          totalUSDSettTaxAmount: 0,
          totalUSDSettUntaxedAmount: 0
        },
        {
          billsAuditStatus: "10",
          estimatedTimeDelivery: "2020-07-02 00:00:00",
          mawbNo: null,
          orderNo: "T2020062800003",
          paymentMethod: 30,
          totalCNYSettTaxAmount: 0,
          totalCNYSettUntaxedAmount: 0,
          totalUSDSettTaxAmount: 0,
          totalUSDSettUntaxedAmount: 0
        }
      ],
      stayTaxRmb: 0,
      stayTaxinclusiveRmb: 0,
      stayTaxUsd: 0,
      stayTaxinclusiveUsd: 0
    };
  },
  mounted() {
    // this.orderMg();
  },
  methods: {
    printEvent(val) {
      if (val === 1) {
        this.print1 = 1;
        this.print2 = 0;
        this.print3 = 0;
        this.print4 = 0;
        this.Settlement = "";
      } else if (val === 2) {
        this.print2 = 1;
        this.print1 = 0;
        this.print3 = 0;
        this.print4 = 0;
        this.Settlement = "10";
      } else if (val === 3) {
        this.print3 = 1;
        this.print1 = 0;
        this.print2 = 0;
        this.print4 = 0;
        this.Settlement = "20";
      } else if (val === 4) {
        this.print4 = 1;
        this.print3 = 0;
        this.print1 = 0;
        this.print2 = 0;
        this.Settlement = "30";
      }
      // this.orderMg();
    },
    handleCurrentChange(val) {
      // this.currentPage = val;
      // this.orderMg();
    },
    //重置
    resetForm() {
      // this.$refs.inquireForm.resetFields();`
    },
    unfold(e, w, s) {
      // var f = (this.flag[w] = !this.flag[w]);
      // this.$set(this.flag, w, f);
      // var tt = e.target;
      // this.zoom = w;
      // if (this.zoom == w && tt.innerText == "展开") {
      //   tt.innerText = "收起";
      // } else if (tt.innerText == "收起") {
      //   tt.innerText = "展开";
      // }
    },
    // 结算基本信息
    orderMg(val) {
      // this.loading = true;
      // let that = this;
      // let len = JSON.parse(sessionStorage.getItem("testKeys"));
      // let lenww = JSON.parse(localStorage.getItem("userInfo"));
      // that
      //   .axios({
      //     method: "post",
      //     url:
      //       that.apiUrl + "/bnwl_oms_business/api/omsChargeAccountList/query",
      //     timeout: 60000,
      //     responseType: "json",
      //     data: {
      //       roleCode: len.roleCode,
      //       customerCode: lenww.customerCode,
      //       billsAuditStatus: this.Settlement,
      //       pageNo: this.currentPage,
      //       creatorOrderCode: lenww.username,
      //       orderNo: this.inquireForm.number,
      //       mawbNo: this.inquireForm.mark,
      //       paymentMethod: this.inquireForm.clearing,
      //       estimatedTimeDeliveryStart: this.inquireForm.value1,
      //       estimatedTimeDeliveryEnd: this.inquireForm.value2
      //     }
      //   })
      //   .then(res => {
      //     this.loading = false;
      //     if (res.data.message == "ok") {
      //       this.listForm = res.data.data;
      //       this.calculate();
      //       return false;
      //     } else {
      //       this.listForm = "";
      //     }
      //   });
    },
    //查询
    inquire() {
      // this.orderMg();
    },
    //计算总金额
    calculate() {
      //   var goods = this.listForm;
      //   var sum = 0;
      //   var sums = 0;
      //   var sue = 0;
      //   var sues = 0;
      //   for (var i = 0; i < goods.length; i++) {
      //     sum += goods[i].totalCNYSettTaxAmount;
      //     sums += goods[i].totalCNYSettUntaxedAmount;
      //     sue += goods[i].totalUSDSettTaxAmount;
      //     sues += goods[i].totalUSDSettUntaxedAmount;
      //   }
      //   this.stayTaxRmb = sums.toFixed(2);
      //   this.stayTaxinclusiveRmb = sum.toFixed(2);
      //   this.stayTaxUsd = sues.toFixed(2);
      //   this.stayTaxinclusiveUsd = sue.toFixed(2);
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/steward/bill.vue